import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import ListCard, {
  ListCardNotDeduction,
  ListCardNotSetDeduction,
} from '../../../components/ListCard';
import Typography from '../../../components/common/Typography';
import { formatNumber, nameRelation } from '../../../common/Util';
import { setSelectedDonationDetail } from './doncationSlice';
import { relationOptions } from '../../../common/data';

/*
  이름 : v.htm038
  관계 : familyCode[v.htm002]
  주민등록번호 : v.htm001
  기부금 항목설정 유무 : v.deType

  기부금 국세청 : htm030
  기부금 국세청 외 : htm060
  급여공제 일괄처리 : htm031
  이월기부금 : htm066 + htm068
  당해년도 공제가능액 : htm067 + htm069
*/
const DonationsItemSection = ({ onOpen }) => {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const { t: tDependents } = useTranslation('dependents');
  const relationList = relationOptions(tDependents);
  const { dataList } = useSelector(state => state.donation);

  const handleClick = data => {
    if (data?.htm001) {
      dispatch(setSelectedDonationDetail({ htmPerRegNum: data?.htm001 }));
      onOpen();
    }
  };

  const content = (data, index, title) => {
    if (data.deType == '1') {
      return (
        <ListCard
          key={index}
          onClick={() => handleClick(data)}
          content={<ListCardContent data={data} title={title} />}
          isFirst={index === 0}
          title="기부금"
        />
      );
    }
    if (data.deType == '2') {
      return <ListCardNotDeduction title={title} key={index} />;
    }

    return <ListCardNotSetDeduction title={title} key={index} />;
  };

  return (
    <div>
      {dataList?.map((data, index) => {
        //이름 (관계)
        let title = nameRelation(tDependents, data);
        return content(data, index, title);
      })}
    </div>
  );
};

export default DonationsItemSection;

const ListCardContent = ({ data, title }) => {
  const { t } = useTranslation('deductions/donations');
  const documentItem = () => {
    if (Number(data?.htm060 || 0) > 0) {
      return t('card.item2');
    } else {
      return t('card.item1');
    }
  };
  return (
    <div>
      <Typography variant="body2Bold">{title}</Typography>
      {/* 기부금 국세청, 국세청외 */}
      <Typography variant="captionMedium">
        {t('card.itemTitle1')}: {formatNumber(data?.htm030 || 0)}
        {t('card.price')} / {t('card.itemTitle2')} : {formatNumber(data?.htm060 || 0)}{' '}
        {t('card.price')}
      </Typography>
      {/* 급여공제 일괄처리, 이월기부금 */}
      <Typography variant="captionMedium" color="Primary-500">
        {t('card.itemTitle3')} : {formatNumber(data?.htm031 || 0)} / {t('card.itemTitle4')} :{' '}
        {formatNumber(Number(data?.htm066 || 0) + Number(data?.htm068 || 0))} {t('card.price')}
      </Typography>
      {/* 당해년도 공제가능액 */}
      <Typography variant="captionMedium" color="Primary-500">
        {t('card.itemTitle5')}:{' '}
        {formatNumber(Number(data?.htm067 || 0) + Number(data?.htm069 || 0))} {t('card.price')}
      </Typography>
      <Typography variant="captionMedium">
        {t('card.itemTitle6')} : {documentItem()}
      </Typography>
    </div>
  );
};
